export const s3Upload = (
  request: XMLHttpRequest,
  file: File,
  progress: (length: boolean, loaded: number, total: number) => void,
  load: (path: string) => void,
  error: (message: string) => void
) => {
  fetch('/api/upload-pdf', {
    method: 'POST'
  })
    .then((resp) => {
      if (resp.ok) {
        return resp.json() as Promise<{
          success: boolean;
          url: string;
          fields: Record<string, string>;
        }>;
      } else {
        throw new Error('Failed to sign upload');
      }
    })
    .then((data) => {
      if (!data?.success) {
        throw new Error('Failed to sign upload');
      }

      return s3UploadWithSignature(
        request,
        file,
        data.url,
        data.fields,
        progress,
        load,
        error
      );
    });
};

export const s3UploadWithSignature = (
  request: XMLHttpRequest,
  file: File,
  url: string,
  fields: Record<string, string>,
  progress: (length: boolean, loaded: number, total: number) => void,
  load: (path: string) => void,
  error: (message: string) => void
) => {
  // fieldName is the name of the input field
  // file is the actual file object to send
  const formData = new FormData();
  for (const key in fields) {
    formData.append(key, fields[key]);
  }

  // file must be appended last
  formData.append('Content-Type', file.type);
  formData.append('Content-Disposition', 'attachment');
  formData.append('file', file, file.name.replace(/\//, ''));

  request.open('POST', url);

  request.upload.onprogress = (e) => {
    progress(e.lengthComputable, e.loaded, e.total);
  };

  request.onload = function () {
    if (request.status >= 200 && request.status < 300) {
      load(file.name);
    } else {
      // error message is not exposed to the client
      error('oh no');
    }
  };

  request.send(formData);

  return request;
};
